import React from 'react';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-unfetch';
import { searchItunes } from '../lib/searchItunes';

import { connect } from 'react-redux';
import { NextSeo } from 'next-seo';
import { searchAllEpisodes } from '../actions';

import Podcast from '../components/Podcast/Podcast';
import PodcastEpisode from '../components/Podcast/PodcastEpisode';
import Loading from '../components/Common/Loading';
import EmptyState from '../components/Common/EmptyState';
import UnsignedInfo from '../components/UnsignedInfo';
import AppCustomLink from '../components/Common/AppCustomLink';

import { Button, Col, Row } from 'antd';
import { spacing } from '../lib/theme';
import { staticAssetsPrefix } from '../lib/utils';
import { throttle } from '../lib/debounce';
import { logSearch, logViewSearchResults } from '../lib/analyticsEvents';
import AppSearchTrending from '../components/Common/AppSearchTrending';
import AppSearchAI from '../components/Common/AppSearchAI';

const searchDelay = 350;

class Search extends React.Component {
  static async getInitialProps(context) {
    const queryTextServer = context.query.text;
    return { queryTextServer };
    // console.dir(queryText);
    // if (typeof queryText !== 'undefined' && queryText.length > 0) {
    //   // const response = await fetch(searchItunes(queryText));
    //   // const json = await response.json();
    //   // return { podcasts: json.results, queryText };
    //   return { queryText };
    // } else {
    //   return { queryText };
    // }
  }

  constructor(props) {
    super(props);
    this.state = { podcasts: undefined, episodes: undefined, searching: true, searchingEpisodes: true, searchType: 2 };
    // this.searchForResults = throttle(this.searchForResults, 500);
    // this.props.loadingUserDetailsState(true);
  }

  componentDidMount() {
    // const { queryText } = this.props;
    // const podcasts = await this.setPageData(queryText);
    const { searchState, queryTextServer } = this.props;
    // let queryText;
    // if (queryTextServer) {
    //   queryText = queryTextServer;
    // } else {
    //   queryText = searchState.searchTerm;
    // }
    // this.searchForResultsCode();
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchState !== prevProps.searchState) {
      const { searchState } = this.props;
      const queryText = searchState.searchTerm;
      this.setState({ podcasts: undefined, episodes: undefined, searching: true, searchingEpisodes: true });
      console.log('searchForResults 00 : ' + queryText);

      // if (this.searchTimeout) {
      //   // return;
      //   clearTimeout(this.searchTimeout);
      // }
      // console.log('searchForResults begin : ' + queryText);
      // this.searchTimeout = setTimeout(async () => {
      //   await this.searchForResultsCode();
      //   // console.log('searchForResults end : ' + queryText);
      //   // this.timerId = undefined;
      // }, searchDelay);
    }
  }

  seeAll = (query, type) => {
    logViewSearchResults(query, type);
  }

  switchType = () => {
    const { searchType } = this.state;
    this.setState({ searchType: searchType == 1 ? 2 : 1 });
  }

  render() {
    // console.dir(this.props);
    const { searchState, userDetails, queryTextServer } = this.props;
    const { podcasts, episodes, searching, searchingEpisodes, searchType } = this.state;
    // console.dir(podcasts);
    // console.dir(searchState);
    // const queryText = searchState.searchTerm;
    let queryText;
    if (queryTextServer) {
      queryText = queryTextServer;
    } else {
      queryText = searchState.searchTerm;
    }
    return (
      <div className='list'>
        <NextSeo
          title={`Podcast Search results for ${queryText}`}
          description={`Podcast Search results for ${queryText}`}
          canonical='https://podurama.com/search'
          openGraph={{
            type: 'website',
            locale: 'en_IE',
            url: `https://podurama.com/search`,
            site_name: 'Podurama',
          }}
        // twitter:{
        //     handle: '@handle',
        //     site: '@site',
        //     cardType: 'summary_large_image',
        // }
        />

        <div className='text-center'>
          <Button type='primary' onClick={this.switchType}>{searchType == 2 ? 'Switch to AI Chatbot (New)' : 'Switch to Normal search'}</Button>
        </div>
        <br />

        {searchType == 1 ?
          <AppSearchAI />
          :
          <>
            {(!queryText || queryText.length < 3) &&
              <div>
                {/* <h3>Please enter a search term above.</h3> */}
                <h4>Trending Searches</h4>
                <AppSearchTrending />
              </div>}
          </>
        }
        {/* <Row> */}


        {/* </Row> */}
        <style jsx>
          {`
          .flex {
            display: flex;
            flex-wrap: wrap;
            // justify-content: space-between;
          }
        `}
        </style>
      </div>
    )
  }
}

Search.propTypes = {
  podcasts: PropTypes.array,
  queryText: PropTypes.string,
  queryTextServer: PropTypes.string,
  searchState: PropTypes.object,
  userDetails: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.userDetails,
    searchState: state.searchState
  }
}

export default connect(mapStateToProps, null)(Search);
